<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel">
      <h3 slot="header" class="modal-header">冲减金额</h3>
      <div style="margin: 0 auto;width: 200px;padding-top: 30px">

        <div style="margin-bottom: 10px">
          实际发生金额：{{formatMoney(costMoney)}} <br> <br>
          请输入冲减金额:</div>
        <InputNumber v-model="value" style="width: 200px;" :min="0" ></InputNumber>
      </div>
    </Modal>
  </div>


</template>
<script>
  import {costdeduct} from "@/api/gop";
  import {formatMoney} from "@/utils/format";

  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      fid: {
        type: String,
        default: ''
      },
      costMoney: {
        type: Number,
        default: 0
      }

    },
    watch: {
      n() {
        this.value = null
        this.isShow = true
      }
    },
    data() {
      return {
        loading: true,
        isShow: false,
        value: null
      }
    },
    methods: {
      formatMoney:formatMoney,
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (!(this.value) && this.value !== 0) {
          this.$Message.info('请输入冲减金额')
          this.changeLoading()
          return
        }
        if(this.value>this.costMoney){
          this.$Message.info('冲减金额不能大于成本金额')
          this.changeLoading()
          return
        }
        let params = {
          fid: this.fid,
          deductionAmount: this.value,
          costMoney: this.costMoney
        }
        costdeduct(params).then(res => {
            this.$emit('done')
            this.$Message.success('操作成功')
          }
        ).catch(error => {
          }).finally(()=>{
            this.isShow=false
        })

      },
      cancel() {

      }

    }

  }
</script>

<style scoped>

</style>
